/**
 * @generated SignedSource<<32310c2bd4e40353009234dda0186760>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarExperience_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FormatRulesNew_view" | "RuleList_rules">;
  readonly " $fragmentType": "ConditionalFormattingSidebarExperience_view";
};
export type ConditionalFormattingSidebarExperience_view$key = {
  readonly " $data"?: ConditionalFormattingSidebarExperience_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperience_view">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarExperience_view",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "FormatRulesNew_view"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RuleList_rules"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};
})();

(node as any).hash = "7a70f6717258bb523e98fc94e7854157";

export default node;
